import logo from './logo.png';
import { APP_NAME } from 'src/config';
import styles from './style.less';

export default function Logo(props) {

    return (
        <div className={styles.root}>
            <h1>{APP_NAME}</h1>
        </div>
    );
}
